export const changeSkin = (newStat) => (dispatch) => {
  // This is a thunk function
  dispatch({
    type: "CHANGE_SKIN",
    payload: {
      skin: newStat,
    },
  });
};
